<div fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="column" fxFlex="80%"
      fxLayoutAlign="space-evenly space-evenly" fxLayoutGap="20px">
      <br />
      <br />
      <h1 i18n="@@privacy-policy-header" name="privacy-policy-header" class="mat-h1"><b>Privacy Policy</b></h1>
      <div class="privacy-policy-container" fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="space-evenly start" fxLayoutGap="5%">
        <div class="container" fxLayout.xs="column" fxLayout.sm="column"  fxLayoutAlign="space-evenly start" fxLayout="row wrap" fxFlex="90%" fxLayoutGap.xs="20px" fxLayoutGap.sm="20px">
            <mat-card class="mat-elevation-z4 container">
                <mat-card-content fxLayout="column" fxLayoutGap="20px" class="content">
                    <p i18n="@@download-the-latest" name="download-the-latest">
                      Download the Latest <a name="privacy-notice" href="javascript:void(0);" (click)="downloadPdf()">Privacy Notice (English)</a> (2021)
                    </p>
                    <div *ngIf="pdfSrc" fxLayoutAlign="center center" fxHide.xs="true" fxHide.sm="true">
                        <pdf-viewer 
                        [src]="pdfSrc"
                        [render-text]="true"
                        [original-size]="false"
                        style="width: 800px; height: 1100px"
                        [autoresize]="true"
                        ></pdf-viewer>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
      </div>
      <div *ngIf="isLoggedIn && !isAdmin" class="browser-note">
        <app-browser-note></app-browser-note>
      </div>
    </div>
</div>
